// extracted by mini-css-extract-plugin
export default {"uploadedImage":"styles_uploadedImage__lLqfI","image":"styles_image__O-pii","description":"styles_description__pbfPT","remove":"styles_remove__vTKdw"};